<template>
  <label class="ui-select-field" :class="{ 'ui-select-field--error': error }">
    <span v-if="label" class="ui-select-field__label">
      {{ label }}
      <span v-if="required">*</span>
    </span>
    <h-s-custom-select
      :model-value="modelValue"
      :options="options"
      :placeholder="placeholder"
      :icon="icon"
      :disabled="disabled"
      :searchable="searchable"
      :search-placeholder="searchPlaceholder"
      :empty-message="emptyMessage"
      :menu-z-index="menuZIndex"
      class="ui-select"
      @update:modelValue="$emit('update:modelValue', $event)"
      @change="$emit('change', $event)"
    />
    <span v-if="hint && !error" class="ui-select-field__hint">{{ hint }}</span>
    <span v-if="error" class="ui-select-field__error">{{ error }}</span>
  </label>
</template>

<script>
import HSCustomSelect from "@/components/common/HSCustomSelect.vue";

export default {
  name: "HsSelect",
  components: { HSCustomSelect },
  props: {
    modelValue: {
      type: [String, Number],
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Select option",
    },
    icon: {
      type: String,
      default: "chevrons-down",
    },
    hint: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    searchable: { type: Boolean, default: false },
    searchPlaceholder: { type: String, default: "Search options..." },
    emptyMessage: { type: String, default: "No results found" },
    menuZIndex: {
      type: [String, Number],
      default: 5200,
    },
  },
  emits: ["update:modelValue", "change"],
};
</script>

<style scoped>
.ui-select-field {
  display: grid;
  gap: 0.42rem;
  min-width: 0;
}

.ui-select-field__label {
  color: var(--hs-text, #0f172a);
  font-size: 0.82rem;
  font-weight: 950;
}

.ui-select-field__label span,
.ui-select-field__error {
  color: var(--hs-danger, #b91c1c);
}

.ui-select {
  min-width: 0;
  width: 100%;
}

.ui-select :deep(.hs-custom-select__button) {
  background: color-mix(in srgb, var(--hs-bg, #f9fafb) 72%, var(--hs-surface, #ffffff));
  border-radius: 15px;
  min-height: 2.75rem;
}

.ui-select-field__hint,
.ui-select-field__error {
  font-size: 0.76rem;
  font-weight: 800;
}

.ui-select-field__hint {
  color: var(--hs-muted, #64748b);
}

.ui-select-field--error .ui-select :deep(.hs-custom-select__button) {
  border-color: color-mix(in srgb, var(--hs-danger, #b91c1c) 55%, var(--hs-border, rgba(148, 163, 184, 0.22)));
  box-shadow: 0 0 0 4px color-mix(in srgb, var(--hs-danger, #b91c1c) 10%, transparent);
}
</style>
